import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app.component';
import { ViewerComponent } from './viewer/viewer.component';
import { ErrorComponent } from './error/error.component';
import { RouterModule, Routes } from '@angular/router';
import { SafePipe } from './tools/SafePipe';
import { NombreSucursalPipe } from './pipes/nombreSucursal.pipe';
import { ViewerCotizacionV2Component } from './viewer-cotizacion-v2/viewer-cotizacion-v2.component';
import { ViewerCotizacionV1Component } from './viewer-cotizacion-v1/viewer-cotizacion-v1.component';
import { VideoModalComponent } from './modals/video-modal/video-modal.component';

const routes: Routes = [
  { path: 'v/:origin/:folio', component: ViewerComponent },
  { path: 'v/:folio', component: ViewerComponent },
  { path: '**', component: ErrorComponent },
];

@NgModule({ declarations: [
        AppComponent,
        ViewerComponent,
        ErrorComponent,
        SafePipe,
        NombreSucursalPipe,
        ViewerCotizacionV2Component,
        ViewerCotizacionV1Component,
        VideoModalComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        RouterModule.forRoot(routes, {
            useHash: true,
            onSameUrlNavigation: 'reload',
        })], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
